module.exports = __webpack_public_path__ + "img/bgc3.0aaaeae4.png";